import EquipmentsList from '../../assets/img/equipments.svg';
import Locations from '../../assets/img/building-community.svg';
import MSEntities from '../../assets/img/Icons_MS_Entities_White.svg';
import MSEvents from '../../assets/img/Icons_MS_Events_White.svg';
import MSEventLog from '../../assets/img/Icons_MS_Event_Log_White.svg';
import MSTickets from '../../assets/img/Icons_MS_Tickets_White.svg';
import MSContracts from '../../assets/img/Icons_MS_Contracts_White.svg';
import Transaction from '../../assets/img/transaction.svg';
import Users from '../../assets/img/people.svg';
import Period from '../../assets/img/period.svg';
import Bank from '../../assets/img/bank.svg';
import DistribuitionList from '../../assets/img/device-desktop-share.svg';
import APMTransaction from '../../assets/img/Icons_APMTransactions_White.svg';
import APMPeriods from '../../assets/img/Icons_APMPeriods_White.svg';
import APMPOS from '../../assets/img/Icons_APMEquipments_White.svg';
import Dashboard from '../../assets/img/home.svg';
import DashboardEntity from '../../assets/img/dashboard_entity.svg';
import MSAuditLogs from '../../assets/img/audit-log-white.svg';
import MSSyncCommands from '../../assets/img/sync-commands.svg';
import MSDevices from '../../assets/img/equipment_parts_logo.svg';
import ProductManagement from '../../assets/img/product-management.svg';
import UserShifts from '../../assets/img/clock-search.svg';
import Products from '../../assets/img/product-ticket.svg';
import userSummaires from '../../assets/img/user-summaries-menu.svg';
import WithdrawSets from '../../assets/img/withdraw-sets.svg';
import CashCollection from '../../assets/img/cash-collection.svg';
import ReasonsDeclarations from '../../assets/img/reasons-declarations.svg';
import { hasPermissions } from './user-permissions';
import { SessionSettings } from '../client-redux/login/reducer';

export interface ViewMapProps {
  label: string | '';
  link: string;
  icon: string;
  order: number; // field menu order;
}

interface ViewMap {
  [key: string]: ViewMapProps;
}

const viewMap: ViewMap = {
  dashboard: {
    icon: Dashboard,
    label: 'DASHBOARD',
    link: '/dashboard',
    order: 3
  },
  dashboardEntity: {
    icon: DashboardEntity,
    label: 'DASHBORAD_ENTITY',
    link: '/dashboardEntity',
    order: 0
  },
  equipment: {
    icon: EquipmentsList,
    label: 'GLOBAL_EQUIPMENTS',
    link: '/equipments',
    order: 4
  },

  branches: {
    icon: Locations,
    label: 'GLOBAL_LOCATIONS',
    link: '/locals',
    order: 5
  },

  enterpriseTransactions: {
    icon: Transaction,
    label: 'TRANSACTIONS',
    link: '/transactions',
    order: 1
  },

  users: {
    icon: Users,
    label: 'GLOBAL_USERS',
    link: '/users',
    order: 7
  },
  periods: {
    icon: Period,
    label: 'ENTERPRISE_EQUIP_PERIODS_SHORT',
    link: '/periods',
    order: 8
  },
  bankTransactions: {
    icon: Bank,
    label: 'BANK_TRANSACTIONS',
    link: '/bankTransactions',
    order: 9
  },
  eventDistributionList: {
    icon: DistribuitionList,
    label: 'GLOBAL_DISTRIBUITIONS',
    link: '/distributions',
    order: 10
  },
  reasonsAndDeclarations: {
    icon: ReasonsDeclarations,
    label: 'EQUIPMENT_REASONS_DECLARATIONS',
    link: '/reasonsDeclarations',
    order: 11
  },
  apmTransactions: {
    icon: APMTransaction,
    label: 'APM_TRANSACTIONS_ACRONYM',
    link: '/apm/transactions',
    order: 12
  },
  apmPeriods: {
    icon: APMPeriods,
    label: 'APM_PERIODS_ACRONYM',
    link: '/apm/periods',
    order: 13
  },
  apmEquipments: {
    icon: APMPOS,
    label: 'APM_POS_ACRONYM',
    link: '/apm/equipments',
    order: 11
  },
  msEquipmentList: {
    icon: EquipmentsList,
    label: 'GLOBAL_EQUIPMENTS',
    link: '/helpdesk/equipments',
    order: 14
  },
  msEntitiesList: {
    icon: MSEntities,
    label: 'GLOBAL_ENTITIES',
    link: '/helpdesk/entities',
    order: 15
  },
  msTicketList: {
    icon: MSTickets,
    label: 'HELPDESK_TICKETS',
    link: '/helpdesk/tickets',
    order: 16
  },
  msAgreement: {
    icon: MSContracts,
    label: 'HELPDESK_CONTRACTS_LABEL',
    link: '/helpdesk/contracts',
    order: 17
  },
  msAuditLogs: {
    icon: MSAuditLogs,
    label: 'GLOBAL_AUDITLOG',
    link: '/helpdesk/auditLogs',
    order: 18
  },
  msSyncCommands: {
    icon: MSSyncCommands,
    label: 'GLOBAL_SYNC_COMMANDS',
    link: '/helpdesk/syncCommands',
    order: 19
  },
  msDevices: {
    icon: MSDevices,
    label: 'GLOBAL_DEVICES',
    link: '/helpdesk/devices',
    order: 20
  },
  msEvents: {
    icon: MSEventLog,
    label: 'EVENT_LOG',
    link: '/helpdesk/events',
    order: 21
  },
  msEventManagement: {
    icon: MSEvents,
    label: 'EVENTS',
    link: '/helpdesk/eventManagement',
    order: 22
  },
  msLocations: {
    icon: Locations,
    label: 'GLOBAL_LOCATIONS',
    link: '/helpdesk/locations',
    order: 23
  },
  productManagement: {
    icon: ProductManagement,
    label: 'PRODUCT_MANAGEMENT_SMALL',
    link: '/helpdesk/productsManagement',
    order: 24
  },
  UserShifts: {
    icon: UserShifts,
    label: 'USER_SHIFT_TITLE',
    link: '/UserShifts',
    order: 2
  },
  cashCollections: {
    icon: CashCollection,
    label: 'CASH_COLLECTIONS',
    link: '/cashCollections',
    order: 10
  },
  products: {
    icon: Products,
    label: 'PRODUCTS_TITLE',
    link: '/products',
    order: 25
  },
  userSummary: {
    icon: userSummaires,
    label: 'BRISA_USERS_SUMMARIES_TITLE',
    link: '/userSummariesList',
    order: 25
  },
  withdrawalSetList: {
    icon: WithdrawSets,
    label: 'BRISA_WITHDRAW_SETS_TITLE',
    link: '/withdrawSetList',
    order: 25
  }
};

let addUnique = function (menus: ViewMapProps[], menu: ViewMapProps) {
  if (!menus.includes(menu)) {
    menus.push(menu);
  }
};
/**
 * Constructs the menu list based on logged user permissions
 * @param {*} userPermissions
 */
export const buildUserMenus = function (userPermissions: any[], settings: SessionSettings) {
  let menus: ViewMapProps[] = [];

  if (!userPermissions || userPermissions.length === 0) {
    console.error('User permissions not found');
    return menus;
  }

  if (hasPermissions(1, 0x01 /* Edit users and permissions */, userPermissions)) {
    addUnique(menus, viewMap.users);
  }

  if (hasPermissions(1, 0x02 /* System Configurations */, userPermissions)) {
    addUnique(menus, viewMap.equipment);
    //addUnique(menus, viewMap.entities);
    addUnique(menus, viewMap.branches);
    settings.useProducts && addUnique(menus, viewMap.products);
    settings.useReasonsAndDeclarations && addUnique(menus, viewMap.reasonsAndDeclarations);
    settings.useEventDistributionList && addUnique(menus, viewMap.eventDistributionList);
    settings.useWithdrawalSet && addUnique(menus, viewMap.withdrawalSetList);
    // if(_zconfig.menus?.biometricRecords){
    //   addUnique(menus, viewMap.biometricRecords);
    // }
    // if(_zconfig.menus?.nonbankuser){
    //   addUnique(menus, viewMap.nonbankuser);
    // }
    // if(_zconfig.menus?.downtime){
    //   addUnique(menus, viewMap.downtime);
    // }
  }

  if (hasPermissions(2, 0x01 /* Financial data */, userPermissions)) {
    settings.useDashboardEntity && addUnique(menus, viewMap.dashboardEntity);
    addUnique(menus, viewMap.dashboard);
    addUnique(menus, viewMap.equipment);
    addUnique(menus, viewMap.enterpriseTransactions);
    settings.useUserBalance && addUnique(menus, viewMap.userSummary);
    settings.useShifts && addUnique(menus, viewMap.UserShifts);
    addUnique(menus, viewMap.periods);
    //addUnique(menus, viewMap.bankTransactions);
    // addUnique(menus, viewMap.bankEquipmentPeriods);
    if (settings?.usePos) {
      addUnique(menus, viewMap.apmPeriods);
      addUnique(menus, viewMap.apmTransactions);
    }
    settings?.useCashCollections && addUnique(menus, viewMap.cashCollections);
  }

  if (hasPermissions(1, 0x04 /* Equipment Remote Operations */, userPermissions)) {
    addUnique(menus, viewMap.equipment);
  }

  if (hasPermissions(1, 0x08 /* Equipment Technician */, userPermissions)) {
    addUnique(menus, viewMap.equipment);
  }

  if (hasPermissions(2, 0x02 /* CIT */, userPermissions)) {
    //addUnique(menus, viewMap.bankEquipmentPeriods);
    addUnique(menus, viewMap.equipment);
    addUnique(menus, viewMap.periods);
    settings?.useCashCollections && addUnique(menus, viewMap.cashCollections);
  }

  if (hasPermissions(2, 0x04 /* Equipment Remote Financial Operations */, userPermissions)) {
    addUnique(menus, viewMap.equipment);
  }

  if (hasPermissions(2, 0x08 /* Operator */, userPermissions)) {
    addUnique(menus, viewMap.enterpriseTransactions);
    settings.useShifts && addUnique(menus, viewMap.UserShifts);
  }

  if (hasPermissions(2, 0x10 /* APM */, userPermissions)) {
    addUnique(menus, viewMap.apmTransactions);
    addUnique(menus, viewMap.apmPeriods);
    addUnique(menus, viewMap.apmEquipments);
    // addUnique(menus, viewMap.apmReports);
  }

  if (hasPermissions(4, 0x08 /* Helpdesk */, userPermissions)) {
    addUnique(menus, viewMap.msEquipmentList);
    addUnique(menus, viewMap.msEntitiesList);
    addUnique(menus, viewMap.msTicketList);
    addUnique(menus, viewMap.msAuditLogs);
    addUnique(menus, viewMap.msSyncCommands);
    addUnique(menus, viewMap.msDevices);
    addUnique(menus, viewMap.msEvents);
    addUnique(menus, viewMap.msLocations);
    //   addUnique(menus, viewMap.msTlogs);
    //   addUnique(menus, viewMap.msCounter);
  }

  if (hasPermissions(4, 0x10 /* Helpdesk Agent */, userPermissions)) {
    addUnique(menus, viewMap.msEquipmentList);
  }

  // if (hasPermissions(4, 0x02 /* Client management */ , userPermissions)) {
  //   addUnique(menus, viewMap.msEquipmentList);
  //   addUnique(menus, viewMap.msEntities);
  //   // addUnique(menus, viewMap.msPosSibs);
  // }
  if (hasPermissions(4, 0x01 /* Agreement management */, userPermissions)) {
    addUnique(menus, viewMap.msAgreement);
  }
  if (hasPermissions(4, 0x20 /* Event & Counter management */, userPermissions)) {
    //   addUnique(menus, viewMap.msCounterDefs);
    addUnique(menus, viewMap.msEventManagement);
  }
  // if (hasPermissions(5, 0x02 /* Manage Productions */ , userPermissions)) {
  //   addUnique(menus, viewMap.msWarehouse);
  //   addUnique(menus, viewMap.billOfMaterials);
  // }
  // if (hasPermissions(5, 0x04 /* Product Reception */ , userPermissions)) {
  //   addUnique(menus, viewMap.receptionProductions);
  //   addUnique(menus, viewMap.documents); //Limited access
  //   addUnique(menus, viewMap.msWarehouse);
  // }
  if (hasPermissions(5, 0x01 /* Manage Products */, userPermissions)) {
    addUnique(menus, viewMap.productManagement);
  }
  // if (hasPermissions(100, 0x02 /* Stocks */ , userPermissions)) {
  //   addUnique(menus, viewMap.stocks);
  //   addUnique(menus, viewMap.stockinout);
  // }
  // if (hasPermissions(100, 0x04 /* Documents */ , userPermissions)) {
  //   addUnique(menus, viewMap.documents);
  // }
  // addUnique(menus, viewMap.userProfile);

  //Sort menus by order
  menus.sort((a, b) => a.order - b.order);

  return menus;
};
